import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07c6e0b5"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的绣球/回音阁", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "电影推荐", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "书籍推荐", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "懂你吧", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "心灵美文", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "成长营", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "系统管理", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    "background-color": "#ffffff",
    "text-color": "#7e7e7e",
    "active-text-color": "#000000",
    router: ""
  }, {
    default: _withCtx(() => [$data.permission[0] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 0,
      index: "0"
    }, {
      title: _withCtx(() => [_hoisted_1]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/diary-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/diary"
      }, {
        default: _withCtx(() => [_createTextVNode("内容管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/diary-comment"
      }, {
        default: _withCtx(() => [_createTextVNode("评论管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission[1] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 1,
      index: "1"
    }, {
      title: _withCtx(() => [_hoisted_2]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/movie-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/movie"
      }, {
        default: _withCtx(() => [_createTextVNode("内容管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/movie-comment"
      }, {
        default: _withCtx(() => [_createTextVNode("评论管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/movie-recommend"
      }, {
        default: _withCtx(() => [_createTextVNode("用户推荐管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission[2] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 2,
      index: "2"
    }, {
      title: _withCtx(() => [_hoisted_3]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/book-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/book"
      }, {
        default: _withCtx(() => [_createTextVNode("内容管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/book-comment"
      }, {
        default: _withCtx(() => [_createTextVNode("评论管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/book-recommend"
      }, {
        default: _withCtx(() => [_createTextVNode("用户推荐管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission[3] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 3,
      index: "5"
    }, {
      title: _withCtx(() => [_hoisted_4]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/questionary-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/questionary"
      }, {
        default: _withCtx(() => [_createTextVNode("心理问卷")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/school"
      }, {
        default: _withCtx(() => [_createTextVNode("学校管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/class"
      }, {
        default: _withCtx(() => [_createTextVNode("班级管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/test-result"
      }, {
        default: _withCtx(() => [_createTextVNode("测试结果")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission[4] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 4,
      index: "3"
    }, {
      title: _withCtx(() => [_hoisted_5]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/article-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/article"
      }, {
        default: _withCtx(() => [_createTextVNode("后台发布管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/article-user"
      }, {
        default: _withCtx(() => [_createTextVNode("用户发布管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/article-comment"
      }, {
        default: _withCtx(() => [_createTextVNode("评论管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.permission[5] == 1 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 5,
      index: "4"
    }, {
      title: _withCtx(() => [_hoisted_6]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/popularization-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("版块概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/popularization"
      }, {
        default: _withCtx(() => [_createTextVNode("内容管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/popularization-comment"
      }, {
        default: _withCtx(() => [_createTextVNode("评论管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), $data.role == 0 || $data.role == 2 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
      key: 6,
      index: "6"
    }, {
      title: _withCtx(() => [_hoisted_7]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "/home/system-overview"
      }, {
        default: _withCtx(() => [_createTextVNode("系统概况")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/user"
      }, {
        default: _withCtx(() => [_createTextVNode("用户管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/report"
      }, {
        default: _withCtx(() => [_createTextVNode("举报管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/opinion"
      }, {
        default: _withCtx(() => [_createTextVNode("反馈评分")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/member"
      }, {
        default: _withCtx(() => [_createTextVNode("成员管理")]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "/home/login-record"
      }, {
        default: _withCtx(() => [_createTextVNode("登录管理")]),
        _: 1
      })]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_menu_item, {
      index: "/login",
      onClick: $options.logout
    }, {
      default: _withCtx(() => [_createTextVNode("退出登录")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  });
}